'use strict';

import Cookie from 'common/Cookie';
import PigeonMaker from 'bsl/utils/PigeonMaker';
import CommonBridge from 'common/CommonBridge';
import { TraceInit } from '@mi/rn-trace';
import Config from '../tmpl/StatCompts/config';

export default class Application {
  constructor(instance, spmref, scm) {
    this.instance = instance;
    this.spmref = spmref;
    this.scm = scm;
  }

  init() {
    // 初始化Pipeon工具链
    const pigeonMaker = new PigeonMaker(this.spmref || '', this.scm || '');
    const pigeonParams = {
      os: this.getOperationSys(),
      device: this.getBrowser(),
      uuid: Cookie.getCookie('youpindistinct_id') || '',
      did: Cookie.getCookie('youpindistinct_id') || '',
      pt: Cookie.getCookie('mjclient'),
      version: '',
      channel: '',
      oaid: '',
      customosversion: 'unknown',
      osversion: '',
    };
    const pigeonCallbacks = {
      sourceCallback: async () => {
        return await CommonBridge.getSource();
      },
      sessionCallback: () => {
        return Cookie.getCookie('youpin_sessionid') || '';
      }, // TODO
      networkCallback: () => {
        return 'unknown';
      },
    };

    pigeonMaker.setEnvParamsAndCallbacks(pigeonParams, pigeonCallbacks);
    // 埋点SDK的 使用用户自己传入的config和自定义的config解析函数
    TraceInit.getInstance(Config);
  }

  setPopModal = (func) => {
    this.showPopModalFunc = func;
  };

  showPopModal = (...args) => {
    this.showPopModalFunc && this.showPopModalFunc(true, ...args);
  };

  hidePopModal = () => {
    this.showPopModalFunc && this.showPopModalFunc(false, null, {});
  };

  uninit() {}

  // setPageNotifyCallback (callback) {
  //   this.notifyCallback = callback;
  // }

  // sendPageNotify (eventname, data, pageId) {
  //   this.notifyCallback && this.notifyCallback(eventname, data, pageId);
  // }

  /**
   * 获取操作系统
   */
  getOperationSys() {
    let OS = '';
    const OSArray = {};
    const UserAgent = navigator.userAgent.toLowerCase();
    OSArray.Windows = navigator.platform == 'Win32' || navigator.platform == 'Windows';
    OSArray.Mac =
      navigator.platform == 'Mac68K' ||
      navigator.platform == 'MacPPC' ||
      navigator.platform == 'Macintosh' ||
      navigator.platform == 'MacIntel';
    OSArray.iphone = UserAgent.indexOf('iPhone') > -1;
    OSArray.ipod = UserAgent.indexOf('iPod') > -1;
    OSArray.ipad = UserAgent.indexOf('iPad') > -1;
    OSArray.Android = UserAgent.indexOf('Android') > -1;
    for (const i in OSArray) {
      if (OSArray[i]) {
        OS = i;
      }
    }
    return OS;
  }

  /**
   * 测浏览器名称
   */
  getBrowser() {
    const UserAgent = navigator.userAgent.toLowerCase();
    let browser = null;
    const browserArray = {
      IE: window.ActiveXObject || 'ActiveXObject' in window, // IE
      Chrome: UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1, // Chrome浏览器
      Firefox: UserAgent.indexOf('firefox') > -1, // 火狐浏览器
      Opera: UserAgent.indexOf('opera') > -1, // Opera浏览器
      Safari: UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1, // safari浏览器
      Edge: UserAgent.indexOf('edge') > -1, // Edge浏览器
      QQBrowser: /qqbrowser/.test(UserAgent), // qq浏览器
      WeixinBrowser: /MicroMessenger/i.test(UserAgent), // 微信浏览器
    };
    for (const i in browserArray) {
      if (browserArray[i]) {
        browser = i;
      }
    }
    return browser;
  }
}
